/**
 * Função retorna um objeto, com o Bearer, utilizado para fazer requisições, com uma
 * rota authenticada, e que necessita de um token dentro do headers.
 * @param {String} token: token de autorização de usuario,
 */
export const headersPadrao = () => {
  let token = JSON.parse(localStorage.getItem("usuarioLogado")).token;
  const header = {
    "Content-Type": "application/json",
    Accept: "application/json",
    Authorization: `Bearer ${token}`,
  };
  return header;
};

/**
 * Função vai retornar os headers especificos para fazer autenticação com google.
 */
export const headersLogin = () => {
  const headerLogin = {
    Accept: "application/json",
  };
  return headerLogin;
};

/**
 * Se caso precisar de um header diferente, ao invés de "Content-Type: application/json", poderá
 * passar o paramentro contentType com um valor diferente.
 * @param {String} contentType: é possível enviar quaisquer tipo de header, porém se não enviar nada
 *                                                       o padrão será application/json
 */
export const headersSimples = (contentType = "application/json") => {
  const outrosHeaders = {
    "Content-Type": contentType,
  };
  return outrosHeaders;
};

export const headersUploadDeArquivo = () => {
  let token = JSON.parse(localStorage.getItem("usuarioLogado")).token;
  const headerUploadArquivo = {
    "Content-Type": "multipart/form-data",
    Authorization: `Bearer ${token}`
  };
  return headerUploadArquivo;
};